export const NECESSARY_ROLES_PER_COMPONENT = {
  RdPlannerButton: [],
  DirectiveComparisonButton: []
}

export const usaFederalAlternativeSimplifiedCreditRefId = 1;

